import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend, { LocizeBackendOptions } from 'i18next-locize-backend';

i18n
  .use(initReactI18next)
  .use(Backend)
  .init<LocizeBackendOptions>({
    backend: {
      projectId: '605a66d7-00ea-4842-b780-aa842fb06b4f',
      referenceLng: 'de-CH',
      version: import.meta.env.VITE_MODE === 'production' ? 'latest' : 'development'
    },
    supportedLngs: ['de-CH', 'fr-CH'],
    lng: 'de-CH',
    ns: ['landing-page'],
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
